module.exports = __webpack_public_path__ + "static/media/screen-individual-05.e8a569f0.jpg";